import {ChoiceProps} from 'hooks/types';
import {useCallback, useState} from 'react';

export type UseSelectedList = {
  selectedItems: ChoiceProps[];
  toggleItemSelectState: (item: ChoiceProps, val?: boolean) => ChoiceProps[];
  isSelected: (item: ChoiceProps) => boolean;
  setSelectedItems: (items: ChoiceProps[]) => void;
};

const useCheckList: (selected?: ChoiceProps[]) => UseSelectedList = selected => {
  const [selectedItems, setSelectedItems] = useState<ChoiceProps[]>(selected || []);

  const toggleItemSelectState = useCallback(
    (item: ChoiceProps, val?: boolean) => {
      const selected = isSelected(item); //check if item in selected list
      // change item to from unselected to selected
      if (val === undefined) val = !selected; //toggle
      if (val && !selected) {
        const newSelectedItems = [...selectedItems, item];
        setSelectedItems(newSelectedItems);
        return newSelectedItems;
      } // change item from selected to unselected
      else if (!val && selected) {
        const newSelectedItems = selectedItems.filter(v => v.id != item.id);
        setSelectedItems(newSelectedItems);
        return newSelectedItems;
      }      
      return selectedItems;
    },    
    [selectedItems],
  );

  const isSelected = useCallback(
    (item: ChoiceProps) => {
      return Boolean(selectedItems.find(v => v.id === item.id));
    },
    [selectedItems],
  );

  return {isSelected, toggleItemSelectState, selectedItems, setSelectedItems};
};

export default useCheckList;
